import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { projects } from '../../data/projects';
export function FeaturedProjects() {
  const featuredProjects = projects.filter(p => p.featured).slice(0, 3);
  return <section className="py-20 bg-ivory" data-id="element-77">
      <div className="max-w-7xl mx-auto px-4" data-id="element-78">
        <SectionHeading title="Featured Projects" subtitle="Transformative initiatives driving sustainable development across Africa" data-id="element-79" />

        <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-80">
          {featuredProjects.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-81">
              <Card hover className="h-full flex flex-col" data-id="element-82">
                <div className="mb-4" data-id="element-83">
                  <StatusPill status={project.status} data-id="element-84">
                    {project.status.toUpperCase()}
                  </StatusPill>
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-85">
                  {project.title}
                </h3>
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-3" data-id="element-86">
                  <MapPinIcon size={16} data-id="element-87" />
                  <span data-id="element-88">{project.countries.join(', ')}</span>
                </div>
                <p className="text-gray-600 mb-4 flex-1" data-id="element-89">
                  {project.description}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-border" data-id="element-90">
                  <span className="text-sm font-medium text-au-green" data-id="element-91">
                    {project.sector}
                  </span>
                  <span className="text-sm font-bold text-charcoal" data-id="element-92">
                    {project.budget}
                  </span>
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-93">
          <Link to="/projects" data-id="element-94">
            <Button variant="secondary" className="flex items-center gap-2 mx-auto" data-id="element-95">
              View All Projects
              <ArrowRightIcon size={20} data-id="element-96" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}